import React from 'react';

import SubtleBadge from 'components/common/SubtleBadge';

export const ADMIN_SHIPPING_PROVIDER_LIST_COLUMNS = [
  {
    accessorKey: 'shipping_provider_type',
    header: 'Name',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { shipping_provider_type } = original;

      return <span>{shipping_provider_type}</span>;
    },
  },
  {
    accessorKey: 'is_active',
    header: 'Status',
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { is_active } = original;

      return (
        <SubtleBadge pill bg={is_active ? 'success' : 'secondary'}>
          {is_active ? 'Active' : 'InActive'}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'sort_order',
    header: 'Sort Order',
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { sort_order } = original;

      return <span>{sort_order}</span>;
    },
  },
];
